.a9{min-width:0px;}